import { lazy } from "react";

const ComprasLayout = lazy(() =>
      import("../../compras/ComprasLayout.jsx")
);

const Compras = lazy(() =>
      import("../../compras/Compras.jsx")
);

const CompraForm = lazy(() =>
      import("../../compras/CompraForm.jsx")
);

const CompraManager = lazy(() =>
      import("../../compras/CompraManager.jsx")
);

const CompraDetalle = lazy(() =>
      import("../../compras/CompraDetalle.jsx")
);

const ComprasSII = lazy(() =>
      import("../../compras/ComprasSII.jsx")
);

const Notas = lazy(() =>
      import("../../compras/Notas.jsx")
);

const comprasRoutes = [
      {
            path: "compras",
            element: <ComprasLayout />,
            children: [
                  { index: true, element: <Compras /> },
                  { path: "nueva", element: <CompraForm /> },
                  { path: "detalle", element: <CompraDetalle /> },
                  { path: "editar", element: <CompraForm /> },
                  { path: "gestionar", element: <CompraManager /> },
                  { path: "sii", element: <ComprasSII /> },
                  { path: "notas", element: <Notas /> },
            ],
      },
];

export default comprasRoutes;